module.exports.units = {
  'million': 'millón',
  'Million': 'Millón',
  'billion': 'mil millones',
  'Billion': 'Mil millones',
  'foot': 'pie',
  'feet': 'pies',
  'mile': 'milla',
  'miles': 'millas',
  'sq. mile': 'milla cuadrada',
  'sq. miles': 'millas cuadradas',
};

module.exports.factNames = {
  'Property value': 'Valor de la propiedad',
  'Home': 'Casa',
  'Homes': 'Casas',
  'Population': 'Población',
  'High social vulnerability population': 'Población de alta vulnerabilidad social',
  'Airport': 'Aeropuerto',
  'Airports': 'Aeropuertos',
  'Power plant': 'Planta energética',
  'Power plants': 'Plantas energéticas',
  'Hazardous waste site': 'Vertedero de residuos peligrosos',
  'Hazardous waste sites': 'Vertederos de residuos peligrosos',
  'Wastewater site': 'Planta de aguas residuales',
  'Wastewater sites': 'Plantas de aguas residuales',
  'Mile of road': 'Milla de carretera',
  'Miles of road': 'Millas de carretera',
  'Hospital': 'Hospital',
  'Hospitals': 'Hospitales',
  'School': 'Escuela',
  'Schools': 'Escuelas',
  'Square mile of land': 'Milla cuadrada de terreno',
  'Square miles of land': 'Millas cuadradas de terreno',
  'House of worship': 'Casa de adoración',
  'Houses of worship': 'Casas de adoración',
  'Museum': 'Museo',
  'Museums': 'Museos',
  'Library': 'Biblioteca',
  'Libraries': 'Bibliotecas',
  'Mile of railroad': 'Milla de ferrocarril',
  'Miles of railroad': 'Millas de ferrocarril',
  'Hazardous materials facility': 'Instalación de materiales peligrosos',
  'Hazardous materials facilities': 'Instalaciónes de materiales peligrosos',
  'Extreme hazmat facility': 'Instalación de desechos muy peligrosos',
  'Extreme hazmat facilities': 'Instalaciones de desechos muy peligrosos',
  'Oil facility': 'Instalación de petróleo',
  'Oil facilities': 'Instalaciónes de petróleo',
  'Pesticide facility': 'Instalación de pesticidas',
  'Pesticide facilities': 'Instalaciones de pesticidas',
  'Sewage plant': 'Planta de aguas negras',
  'Sewage plants': 'Plantas de aguas negras',
  'Government building': 'Edificio gubernamental',
  'Government buildings': 'Edificios gubernamentales',
  'College': 'Colegio',
  'Colleges and universities': 'Colegios y Universidades',
  'Assisted living facility': 'Centro de vivienda asistida',
  'Assisted living facilities': 'Centros de vivienda asistida',
  'EPA OIL site': 'Sitio OIL de la EPA',
  'EPA OIL sites': 'Sitios OIL de la EPA',
  'TV transmitter site': 'Emplazamiento de transmisor de TV',
  'TV transmitter sites': 'Emplazamientos de transmisores de TV',
  'FM radio transmitter site': 'Emplazamiento de transmisor de radio FM',
  'FM radio transmitter sites': 'Emplazamientos de transmisores de radio FM',
  'Local road': 'Carretera local',
  'Local roads': 'Carreteras locales',
  'Primary road': 'Carretera principal',
  'Primary roads': 'Carreteras principales',
  'Secondary road': 'Camino secundario',
  'Secondary roads': 'Caminos secundarios',
  'Federal road': 'Carretera federal',
  'Federal roads': 'Carreteras federales',
  'State road': 'Carretera estatal',
  'State roads': 'Carreteras estatales',
  'County road': 'Carretera del condado',
  'County roads': 'Carreteras del condado',
  'Passenger rail': 'Vías ferroviarias de pasajeros',
  'Amtrak rail': 'Vías ferroviarias de Amtrak',
  'Transit rail': 'Vías ferroviarias de tránsito masivo',
  'Mainline rail': 'Vías principales de ferrocarril',
  'Non-mainline rail': 'Vías de ferrocarril no principales',
  'Protected land': 'Tierras protegidas',
  'Federal protected land': 'Tierras protegidas federalmente',
  'State protected land': 'Tierras protegidas por el estado',
  'Local protected land': 'Tierras protegidas localmente',
  'National Park Service land': 'Tierras del Servicio Nacional de Parques',
  'Fish & Wildlife Service land': 'Tierra del Servicio de Pesca y Vida Silvestre',
};

module.exports.emisDesc = {
  'moderate cuts in': 'reducciones moderadas de',
  'minor cuts in': 'reducciones menores de',
  'unchecked': 'ningunas reducciones en',
  'extreme cuts in': 'reducciones extremas de',
};

module.exports.whenSentences = {
  default: 'Estos rangos corresponden a %emisDesc% de contaminantes que atrapan calor y proyecciones locales del aumento del nivel del mar entre %lowModel% y %highModel% pies para el año 2100, dependiendo en la sensibilidad del modelo al cambio climático. La probabilidad de al menos una inundación antes de %bestYear% que excede %waterLevel% pies oscila entre %pathwayLow% y %pathwayHigh%, y esto depende en los niveles de polución y la sensibilidad del modelo.',
  ACE: 'Los rangos mostrados derivan del escenario bajo contra el escenario alto del nivel del mar global del Cuerpo de Ingenieros del Ejército de EE.UU. (U.S. Army Corps of Engineers), los cuales indican pronósticos locales del aumento del nivel del mar de %lowModel% contra %highModel% pies para el 2100. El escenario bajo asume que el ritmos histórico del siglo veinte del aumento del nivel del mar continuará, mientras que el escenario alto refleja contaminación descontrolada y una pérdida acelerada de las capas de hielo.',
  NCA: 'Los rangos mostrados derivan del escenario intermedio bajo versus los escenarios más altos del nivel del mar global de la Evaluación Nacional del Clima de los EE.UU (U.S. National Climate Assessment) de 2014, los cuales indican pronósticos locales del aumento del nivel del mar de %lowModel% versus %highModel% pies para el 2100. El escenario más bajo corresponde a niveles bajos de contaminantes que atrapan calor en el futuro, mientras que el más alto refleja la contaminación descontrolada y el derretimiento más rápido de las capas de hielo.',
  NOAA2017: 'Los rangos mostrados derivan del escenario intermedio bajo contra el escenario intermedio alto del nivel del mar global de un reporte técnico del 2017 de NOAA para uso en la Evaluación Nacional del Clima de EE.UU (U.S. National Climate Assessment). Estos pronósticos indican aumentos locales del nivel del mar de %lowModel% contra %highModel% pies para el 2100. Mientras se emiten más contaminantes que atrapan calor, más alto será el aumento del nivel del mar.',
  NRC: 'Los rangos mostrados derivan del escenario bajo contra el escenario alto del nivel del mar global de un reporte de 2012 del Consejo Nacional de Investigaciones de EE.UU. (U.S. National Research Council) para los estados del Pacífico. Estos pronósticos indican aumentos locales del nivel del mar de %lowModel% contra %highModel% pies para el 2100. El escenario bajo corresponde a niveles bajos de contaminantes que atrapan calor en el futuro, mientras que el escenario alto refleja la contaminación descontrolada y un derretimiento dinámico de las capas de hielo.',
};

module.exports.unnatural = {
  default: 'Aproximadamente dos tercios de los días de inundación costera en los EE.UU. desde 1950 no hubieran cumplido con la definición local de inundación del Servicio Nacional de Meteorología, si no por las pulgadas de aumento del nivel del mar impulsado por cambios en el clima por la mano del hombre.',
  station: 'Desde 1950, un mareógrafo en %stationLocation% ha registrado %floodDays% días que exceden los umbrales de inundación del Servicio Nacional de Meteorología (National Weather Service). Sin el aumento del nivel del mar causado por el calentamiento global, el conteo sería %baselineFloodDays%. Esta estación está a %miles% millas de %placeName%.',
};

module.exports.footnote = {
  default: 'Los pronósticos del nivel del mar y de los riesgos de inundación están adaptados a nivel local en base a los métodos en Tebaldi et al. 2012 (Cartas de Investigaciones Ambientales).',
  AR5: 'Proyecciones locales del nivel del mar y de inundación se basan en pronósticos de baja- y alta-sensibilidad del nivel del mar global del IPCC (2013). %emisDesc% contaminantes que atrapan calor indica la Vía de Concentración Representativa %pathway%.',
  BK: 'Proyecciones del nivel del mar y de inundación se basan en pronósticos locales de percentil 5-95 de Kopp et al. 2014 (Earth\u2019s Future). %emisDesc% indica Vía de Concentración Representativa %pathway%.',
  DP16: 'Los pronósticos locales del nivel del mar se basan en Kopp et al. 2017 (Earth\u2019s Future), que incorpora la nueva física antártica de DeConto y Pollard 2016 (Nature). \u201C%emisDesc% contaminación que atrapa calor\u201D indica Vía de Concentración Representativa %pathway%.',
  NRC: 'Los pronósticos del nivel del mar y de los riesgos de inundación están adaptados a nivel local en base los datos de NRC y los métodos en Tebaldi et al. 2012 (Cartas de Investigaciones Ambientales).',
};

module.exports.mapCaption = {
  sovi: 'Vulnerabilidad social (por ej. por bajos ingresos) intensifica los riesgos costeros. Tierras bajo %waterLevel% %unit% están coloreadas de acuerdo a la leyenda. Surging Seas utiliza datos lidar de elevación de alta precisión proporcionados por la NOAA. El mapa refleja un nivel del mar y/o altura de inundación uniforme. Eventos individuales de marejadas ciclónicas, marea, o precipitación, causan superficies menos uniformes y más complejas.',
  property: 'Tierras bajo %waterLevel% %unit% están coloreadas de acuerdo a la leyenda. Surging Seas utiliza datos lidar de elevación de alta precisión proporcionados por la NOAA. El mapa refleja un nivel del mar y/o altura de inundación uniforme. Eventos individuales de marejadas ciclónicas, marea, o precipitación, causan superficies menos uniformes y más complejas.',
  satellite: 'Tierras bajo %waterLevel% %unit%.',
};
